"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyButton = ApplyButton;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const prop_types_1 = __importDefault(require("prop-types"));
const pattern_library_utils_cookies_1 = require("@saatva-bits/pattern-library.utils.cookies");
const utils_1 = require("../../../../utils");
const middleware_1 = require("../../../../middleware");
const launch_darkly_widget_module_scss_1 = __importDefault(require("../../launch-darkly-widget.module.scss"));
function ApplyButton({ overrides }) {
    return ((0, jsx_runtime_1.jsx)("button", { role: "button", className: launch_darkly_widget_module_scss_1.default.applyButton, onClick: () => applyNewOverrides(overrides), children: "Apply Changes" }));
}
// we utilize the query param method for applying overrides for the current user
const applyNewOverrides = async (newOverrides) => {
    try {
        const ldoCookie = pattern_library_utils_cookies_1.Cookies.get(middleware_1.LD_OVERRIDE_COOKIE_NAME) || null;
        const existingOverrides = ldoCookie ? (0, utils_1.seperateEncodedFlags)(ldoCookie) : {};
        const combinedOverrides = { ...existingOverrides, ...newOverrides };
        /*
            In order to reduce cache keys for the ldo cookie, we want to remove overrides from
            the final set if they exist in both new and existing sets but with different values, indiating
            the new override is resetting back to the initial flag state (and thus doesn't need an ldo cookie setting)
        */
        Object.keys(combinedOverrides).forEach(key => {
            const existingOverride = existingOverrides[key];
            const newOverride = newOverrides[key];
            if (existingOverride !== undefined &&
                newOverride !== undefined &&
                existingOverride !== newOverride) {
                delete combinedOverrides[key];
            }
        });
        /* Set cookie with copounded overrides if set exists */
        if (Object.keys(combinedOverrides).length !== 0) {
            const encodedCookie = (0, utils_1.encodeLdCookieValue)(combinedOverrides);
            pattern_library_utils_cookies_1.Cookies.set(middleware_1.LD_OVERRIDE_COOKIE_NAME, encodedCookie, { maxAge: middleware_1.LD_COOKIE_TLL }); // 3 months
        }
        else {
            /* Remove cookie no overrides are set */
            pattern_library_utils_cookies_1.Cookies.remove(middleware_1.LD_OVERRIDE_COOKIE_NAME);
        }
        /* Assuming no race conditions, we can reload synchronously. If we do run into them, a page refresh will have the new cookie. */
        location.reload();
    }
    catch (error) {
        console.log('[LaunchDarklyWidget.applyNewOverrides] error applying overrides:', error);
    }
};
ApplyButton.propTypes = {
    /** overrides that have been selected in the widget  */
    overrides: prop_types_1.default.objectOf(prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string, prop_types_1.default.bool])).isRequired
};
//# sourceMappingURL=ApplyButton.js.map